// extracted by mini-css-extract-plugin
export var clients = "clients-list-module--clients--1zltL";
export var introCopyContainer = "clients-list-module--introCopyContainer--3aauN";
export var clientsList = "clients-list-module--clientsList--2U3h1";
export var clientsListSection = "clients-list-module--clientsListSection--2w-_w";
export var clientsListSectionBlockContent = "clients-list-module--clientsListSectionBlockContent--2jiKn";
export var sectionButton = "clients-list-module--sectionButton--2TwLJ";
export var letterContainer = "clients-list-module--letterContainer--3Cy1a";
export var plus = "clients-list-module--plus--1HUTA";
export var expanded = "clients-list-module--expanded--38iIj";
export var mobileClientsList = "clients-list-module--mobileClientsList--1Lh-q";